const debounceSearch = (func, delay) => {
    let timer;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(context, args), delay);
    }
}
const formatHeaderMoney = (amount) => {
    const formattedPrice = Number(amount).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });

      return formattedPrice;
}

// Storefront API config
const searchApiURL = "https://aribikes.myshopify.com/api/2024-01/graphql.json";
const searchApiToken = "2861f5e893e2ce31e62c929cc7856923";

// Fetch product variants and get comp price
const getCompPrice = async (productHandle) => {
    const query = `{
        product(handle: "${productHandle}") {
            variants(first: 50) {
                edges {
                    node {
                        title
                        price {
                            amount
                        }
                    }
                }
            }
        }
    }`;

    try {
        const response = await fetch(searchApiURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': searchApiToken
            },
            body: JSON.stringify({ query })
        });

        const data = await response.json();
        const variants = data?.data?.product?.variants?.edges || [];

        const normalize = (title) => title.toLowerCase();

        const sportVariants = variants.filter(v => {
            const title = normalize(v.node.title);
            return title.includes('sport') && !title.includes('600 wh');
        });

        if (sportVariants.length > 0) {
            const lowestSport = sportVariants.reduce((min, v) =>
                parseFloat(v.node.price.amount) < parseFloat(min.node.price.amount) ? v : min
            );
            return { price: lowestSport.node.price.amount, type: 'sport' };
        }

        const compVariants = variants.filter(v => {
            const title = normalize(v.node.title);
            return title.includes('comp') && !title.includes('600 wh');
        });

        if (compVariants.length > 0) {
            const lowestComp = compVariants.reduce((min, v) =>
                parseFloat(v.node.price.amount) < parseFloat(min.node.price.amount) ? v : min
            );
            return { price: lowestComp.node.price.amount, type: 'comp' };
        }

        return null; // No comp variant found
    } catch (error) {
        console.error('Error fetching comp price:', error);
        return null;
    }
};

const trueTypeOf = (obj) => {
    return Object.prototype.toString
      .call(obj)
      .slice(8, -1)
      .toLowerCase();
}

const objectToQueryParams = (obj, parentKey) => {
    var output = '';
    parentKey = parentKey || null;
  
    Object.keys(obj).forEach(function(key) {
      var outputKey = key + '=';
      if (parentKey) {
        outputKey = parentKey + '[' + key + ']';
      }
  
      switch (trueTypeOf(obj[key])) {
        case 'object':
          output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
          break;
        case 'array':
          output += outputKey + '=' + obj[key].join(',') + '&';
          break;
        default:
          if (parentKey) {
            outputKey += '=';
          }
          output += outputKey + encodeURIComponent(obj[key]) + '&';
          break;
      }
    });
  
    return output;
}

const buildProducts = async (products) => {
    const bikes = products.filter(product => product.type === 'bike' || product.type === 'gear' || product.type === 'outlet');
    if (bikes.length === 0) return;

    // Process all products in parallel for better performance
    const productPromises = bikes.map(async (product) => {
        if (product.price_min === "0.00") return null;

        // Extract handle from URL (e.g., "/products/la-sal-peak" -> "la-sal-peak")
        const handle = product.url.split('/products/')[1]?.split('?')[0];

        // Try to get comp variant price
        let displayPrice = product.price_min;
        let pricePrefix = 'From';

        if (handle) {
            const compResult = await getCompPrice(handle);
            if (compResult) {
                displayPrice = compResult.price;
                pricePrefix = 'From';
            }
        }

        return { product, displayPrice, pricePrefix };
    });

    const results = await Promise.all(productPromises);

    // Render results
    results.forEach((result) => {
        if (!result) return;

        const { product, displayPrice, pricePrefix } = result;

        $('.search-item-results').find('ul').append(`
            <li>
                <a href="${product.url}">
                    <div class="search-item-image">
                        <img src="${product.featured_image.url}" alt="${product.featured_image.alt}">
                    </div>
                    <div class="search-item-details">
                        <span>Product</span>
                        <h4>${product.title}</h4>
                        <span class="product-price">${pricePrefix} ${formatHeaderMoney(displayPrice)}</span>
                    </div>
                </a>
            </li>
        `);
        // Mobile view
        $('.nav-mobile-results-inner-container').find('ul').append(`
        <li>
            <a href="${product.url}">
            <div class="nav-mobile-item-image">
                <img src="${product.featured_image.url}" alt="${product.featured_image.alt}">
            </div>
            <div class="nav-mobile-item-details">
                <span>Product</span>
                <h4>${product.title}</h4>
                <span class="product-price">${pricePrefix} ${formatHeaderMoney(displayPrice)}</span>
            </div>
            </a>
        </li>
        `);
    });

    $('.search-item-results').removeClass('hidden');
    $('.nav-mobile-results-inner-container').removeClass('hidden');
}

const buildCategory = (categories) => {
    // console.log('category: ', categories);
    if (categories.length === 0)  return;
    categories.forEach((category, index) => {
        $('.search-item-results, .nav-mobile-results-inner-container').find('ul').append(`
            <li>
                <a href="${category.url}">
                    <div class="search-item-image no-bg">
                        <img src="${category.featured_image.url}" alt="${category.featured_image.alt}">
                    </div>
                    <div class="search-item-details">
                        <span>Category</span>
                        <h4>${category.title}</h4>
                    </div>
                </a>
            </li>
        `);
    });
    $('.search-item-results, .nav-mobile-results-inner-container').removeClass('hidden');
}

const search = (query) => {
    if (query.length > 2) {
        $('.search-item-default, .nav-mobile-defaults').addClass('hidden');
        $('.nav-mobile-results-inner-container').find('h3').text('Search Results');
        $('.nav-mobile-results-inner-container').find('.search-term').find('p').text(query);
        $('.header-search-details-inner-container').find('p').text('Searching for ' + query).removeClass('hidden no-results');
        // console.log(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[options][fields]=title,product_type,variants.title,author,body,tag,vendor&section_id=predictive-search`);
        $.ajax({
            type: 'GET',
            url: `/search/suggest.json?q=${query}&resources[options][fields]=title,product_type,variants.title,author,body,tag,vendor`,
            success: async function(data) {
                console.log("Search results: ", data.resources.results);
                $('.search-item-results, .nav-mobile-results-inner-container').find('ul').empty();
                await buildProducts(data.resources.results.products);
                buildCategory(data.resources.results.collections);
                // console.log(data);

                $('.nav-mobile-results-inner-container').find('.search-term').find('span').text(`(${$('.nav-mobile-results-inner-container').find('ul').children().length})`);
                if ($('.search-item-results').find('ul').children().length === 0 && $('.nav-mobile-results-inner-container').find('ul').children().length === 0) {
                    $('.header-search-details-inner-container').find('p').text('No results found for '+ query).addClass('no-results');
                    $('.search-item-default').removeClass('hidden');

                    $('.nav-mobile-results-inner-container').find('h3').text('No results found for ' + query);
                    $('.nav-mobile-defaults').removeClass('hidden');

                    return;
                }

                $('.header-search-details-inner-container').find('p').addClass('hidden no-results');
            }
        })
    } else {
        $('.header-search-details-inner-container').find('p').addClass('hidden')
        $('.search-item-default, .nav-mobile-defaults').removeClass('hidden');
        $('.search-item-results').addClass('hidden');
        $('.nav-mobile-results-inner-container').addClass('hidden');
    }

}

document.addEventListener('DOMContentLoaded', function () {

    const navSearch = debounceSearch(search, 300);

    const closeSearch = () => {
        $('.header-icon-cart').css({"opacity": "1", "visibility": "visible"});
        $('.nav-main-search-close').addClass('hidden');
        $('.nav-main-search-container').addClass('hidden');
        $('.header-search-details-container').addClass('hidden');
        $('[data-header-search-backdrop]').addClass('hidden');
        $('.search-item-default').addClass('hidden');
        $('.search-item-results').addClass('hidden');
        $('.nav-main-search-inner-container').find('input').val('');

        // enable body scroll
        $('body').css({"overflow": "auto"});
    }

    $("[data-desktop-search]").on('keyup', function() {
        navSearch($(this).val());
    });

    $("[data-mobile-search]").on('keyup', function() {
        navSearch($(this).val());
    });

    $('.header-icon-search').on('click', function(e) {
        e.preventDefault();
        $('.header-icon-cart').css({"opacity": "0", "visibility": "hidden"});
        $('.nav-main-search-close').removeClass('hidden');
        $('.nav-main-search-container').removeClass('hidden');
        $('.header-search-details-container').removeClass('hidden');
        $('[data-header-search-backdrop]').removeClass('hidden');
        $('.search-item-default').removeClass('hidden');
        $('.nav-main-search-inner-container').find('input').focus();

        // disable body scroll
        $('body').css({"overflow": "hidden"});
    })

    $('.nav-main-search-close').on('click', function(e) {
        e.preventDefault();
        closeSearch();
        
    });

    $('[data-header-search-backdrop]').on('click', function(e) {
        e.preventDefault();
        
        closeSearch();
    });

    $('body').on('click', function(e) {
        // closeSearch();
    });

    $('.nav-mobile-search-input input').on('focus', function() {
        $('.nav-mobile-search-close').removeClass('hidden');
        $('.nav-mobile-results').removeClass('hidden');
        $('.nav-mobile-logo').addClass('hidden');
        $('.nav-mobile-links').addClass('hidden');
    });

    $('.nav-mobile-search-close').on('click', function() {
        $(this).addClass('hidden');
        $('.nav-mobile-results').addClass('hidden');
        $('.nav-mobile-logo').removeClass('hidden');
        $('.nav-mobile-links').removeClass('hidden');

        $("[data-mobile-search]").val('');
    });

    // Mobile nav links
    $('.nav-mobile-links').on('click', 'button', function() {
        // check first if the button data-link is not null
        if ($(this).data('link-url') === 'n-a') return;
        // navigate to the link
        window.location.href = $(this).data('link-url');
    });

    $('.header-icon-menu').on('click', 'a', function(e) {
        e.preventDefault();
        $('.nav-mobile-link-lists').css({"opacity": "1", "visibility": "visible", "left": "0"});
        // disable body scroll
        $('body').css({"overflow": "hidden"});
    });

    $('.nav-mobile-close').on('click', function(e) {
        e.preventDefault();
        // enable body scroll
        $('body').css({"overflow": "auto"});
        $('.nav-mobile-link-lists').css({"left": "620px"})
        setTimeout(() => {
            $('.nav-mobile-link-lists').css({"opacity": "0", "visibility": "hidden"});
        }, 800);
    })

    $('.nav-mobile-defaults').on('click', 'a', function(e) {
        e.preventDefault();
        // trigger on keyup on the search input
        $("[data-mobile-search], [data-desktop-search]").val($(this).text());
        $("[data-mobile-search], [data-desktop-search]").trigger('keyup');
    });
    $('.search-item-default').on('click', 'a', function(e) {
        e.preventDefault();
        // trigger on keyup on the search input
        $("[data-desktop-search]").val($(this).text());
        $("[data-desktop-search]").trigger('keyup');
    });
});